import { FC } from 'react';
import { Oval } from 'react-loader-spinner';

export const SmallLoader: FC<{ height?: number; width?: number }> = ({
  height = 20,
  width = 20,
}) => {
  return (
    <span className="louder-small-wrapper-custom">
      <Oval secondaryColor="grey" color="#2914e4" height={height} width={width} />
    </span>
  );
};
